var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d2-container',[_c('p',{staticClass:"d2-mt-0"},[_vm._v("useragent")]),_c('el-input',{attrs:{"value":_vm.uaData.ua}}),_c('p',[_vm._v("格式化数据 in vuex: state.d2admin.ua.data")]),_c('d2-highlight',{attrs:{"code":_vm.uaStr}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }